import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "./actionTypes";
import * as actions from "./actions";
import { getPermissions } from "../../services/permission";

function* fetchPermissions() {
  try {
    const data = yield call(getPermissions);
     console.log("🔥 API response:", data);
    yield put(actions.fetchPermissionsSuccess(data));
  } catch (error) {
    yield put(actions.fetchPermissionsFailure());
  }
}

export function* watchAuthSaga() {
  yield takeLatest(types.FETCH_PERMISSIONS_REQUEST, fetchPermissions);
}

export default watchAuthSaga;
